import toast from "react-hot-toast";
import * as api from "../Api";
import { message } from "antd";
import { errorMessage } from "../utils/errorMessage";

// create a  new asset
export const getCompanyAsset = () => async (dispatch) => {
  let fetchingId;
  try {
    toast.dismiss();
    fetchingId = toast.loading("Loading System Data....");
    const { data } = await api.fetchAssets();
    dispatch({ type: "FETCH_ALL_ASSET", payload: data });
    toast.dismiss();
    toast.remove(fetchingId);
    message.info("System Data Successfully Loaded");
  } catch (error) {
    toast.remove(fetchingId);
    toast.error(errorMessage(error));
  }
};

export const createCompanyAsset = (postData) => async (dispatch) => {
  let creatingId;
  try {
    creatingId = toast.loading("Submitting asset for approval....");
    const { data } = await api.createAsset(postData);
    dispatch({ type: "CREATE_ASSET", payload: data });
    toast.remove(creatingId);
    toast.success("Successfully submitted");
    return data;
  } catch (error) {
    toast.remove(creatingId);
    toast.error(errorMessage(error));
    throw error;
  }
};

export const transferAsset = (id, postData) => async (dispatch) => {
  let updatingId;
  try {
    updatingId = toast.loading("Saving changes...");
    const { data } = await api.updateAsset(id, postData);
    dispatch({
      type: "TRANSFER_ASSET",
      payload: {
        id,
        // stored in lowercase, like the rows loaded from the server
        location: String(postData.location || "").toLowerCase(),
        sub_location: String(postData.sub_location || "").toLowerCase(),
      },
    });
    toast.remove(updatingId);
    toast.success("Asset successfully transferred");
    return data;
  } catch (error) {
    toast.remove(updatingId);
    toast.error(errorMessage(error));
    throw error;
  }
};
